import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';

import { UsuarioListComponent } from './usuario-list/usuario-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ListboxModule } from 'primeng/listbox';
import { PainelModule } from 'src/app/shared/components/painel/painel.module';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { ToastModule } from 'primeng/toast';
import { SliderModule } from 'primeng/slider';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';
import { VMessageModule } from 'src/app/shared/components/vmessage/vmessage.module';
import { MessageService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { AutoCompleteModule } from 'primeng/autocomplete';


@NgModule({
  declarations: [UsuarioListComponent,EsqueciSenhaComponent],
  imports: [
  TooltipModule,
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    FileUploadModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputTextModule,
    InputNumberModule,
    DialogModule,
    BrowserModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
    PipesModule,
    ListboxModule,
    PainelModule,
    CommonModule,
    InputTextModule,
    CalendarModule,
    TableModule,
    ButtonModule,
    PaginatorModule,
    DialogModule,
    RouterModule,
    ToastModule,
    SliderModule,
    FormsModule,
    DirectivesModule,
    ReactiveFormsModule,
    VMessageModule,
    PainelModule,
    DropdownModule,
    CardModule,
    AutoCompleteModule,
  ],
  exports: [UsuarioListComponent, EsqueciSenhaComponent],
  providers: [DatePipe, MessageService, ToastModule]
})
export class UsuarioModule { }